import { toast } from "@/hooks/use-toast";

const WARN_THRESHOLD = 0.85;
let warnedThisSession = false;

/** Best-effort storage estimate; returns null when API unavailable. */
export async function estimateStorageUsage(): Promise<{
  usage: number;
  quota: number;
  ratio: number;
} | null> {
  if (!navigator.storage?.estimate) return null;
  try {
    const { usage = 0, quota = 0 } = await navigator.storage.estimate();
    if (!quota) return null;
    return { usage, quota, ratio: usage / quota };
  } catch {
    return null;
  }
}

/** Warn once per session when local storage is nearly full. */
export async function warnIfStorageNearlyFull(): Promise<void> {
  if (warnedThisSession) return;
  const est = await estimateStorageUsage();
  if (!est || est.ratio < WARN_THRESHOLD) return;
  warnedThisSession = true;
  toast({
    title: "Storage almost full",
    description:
      "Free up browser storage for Office Rhythm to keep saving your preferences.",
    variant: "destructive",
  });
}

export function notifyStorageWriteFailed(): void {
  toast({
    title: "Could not save locally",
    description: "Your browser storage may be full or disabled.",
    variant: "destructive",
  });
}
